export default __webpack_public_path__ + "static/media/Acolyte's Gloves of Sacrifice.0265a63d.jpg";